<app-title-section></app-title-section>

<div class="card rapport-detail-card">
    <div class="mt-2 mb-3 cursor-pointer" style="margin-left: 24px; color: #2F2B3DE5" (click)="retour()">

        <i data-feather="arrow-left" [size]="18"> </i>
        Retour
    </div>
    <app-filtre-date> </app-filtre-date>

    <div style=" border-bottom: 1px solid #eee; margin-top: 29px; margin-bottom: 29px"></div>
    <div class="d-flex">
        <div class="justify-content-start" style="margin-bottom: 24px">
            <span style="font-size: 20px; margin-left: 24px; color: #2F2B3DE5">{{ reportName || 'Rapport' }} </span>
        </div>
        <div class="d-flex col-auto ms-auto" style="margin-left: auto;margin-right: 24px ; gap: 13px;align-items: center">
            <ng-select
                *ngIf="showGroupBySelect"
                class="rapport-filter-ng-select"
                [items]="rapportGroupByOptions"
                bindLabel="label"
                bindValue="id"
                [(ngModel)]="selectedGroupById"
                name="rapport_group_by"
                placeholder="Groupez par"
                [clearable]="true"
                [searchable]="false"
                appendTo="body"
                dropdownClass="rapport-ng-dropdown-panel"
            ></ng-select>

            <ng-select
                *ngIf="showProductSelect"
                class="rapport-filter-ng-select rapport-filter-ng-select--product"
                [items]="rapportProducts"
                bindLabel="nom"
                bindValue="id"
                [(ngModel)]="selectedProductId"
                (ngModelChange)="onRapportProductChange($event)"
                name="rapport_produit"
                placeholder="sélectionnez un produit"
                [loading]="isLoadingProducts"
                [clearable]="true"
                [searchable]="true"
                notFoundText="Aucun produit trouvé"
                appendTo="body"
                dropdownClass="rapport-ng-dropdown-panel"
            >
                <ng-template ng-option-tmp let-item="item">
                    <div class="rapport-product-select-option">
                        <span class="rapport-product-select-option__name">{{ item?.nom || '—' }}</span>
                        <small
                            *ngIf="item?.code_bar || item?.code_barre"
                            class="rapport-product-select-option__barcode d-block"
                        >{{ item?.code_bar || item?.code_barre }}</small>
                    </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    <div class="rapport-product-select-option rapport-product-select-option--label">
                        <span class="rapport-product-select-option__name">{{ item?.nom || '—' }}</span>
                        <small
                            *ngIf="item?.code_bar || item?.code_barre"
                            class="rapport-product-select-option__barcode d-block"
                        >{{ item?.code_bar || item?.code_barre }}</small>
                    </div>
                </ng-template>
            </ng-select>

            <ng-select
                *ngIf="showContactSelect && !useFournisseurContactSelect"
                class="rapport-filter-ng-select rapport-filter-ng-select--contact"
                [items]="contactClients"
                bindLabel="nom_prenom"
                bindValue="id"
                [(ngModel)]="selectedContactId"
                (ngModelChange)="onRapportContactChange($event)"
                name="contact_client_rapport"
                placeholder="sélectionnez un contact"
                [loading]="isLoadingContacts"
                [clearable]="true"
                [searchable]="true"
                notFoundText="Aucun client trouvé"
                appendTo="body"
            ></ng-select>

            <ng-select
                *ngIf="showContactSelect && useFournisseurContactSelect"
                class="rapport-filter-ng-select rapport-filter-ng-select--contact"
                [items]="rapportFournisseurs"
                bindLabel="nom_entreprise"
                bindValue="id"
                [(ngModel)]="selectedContactId"
                (ngModelChange)="onRapportContactChange($event)"
                name="contact_fournisseur_rapport"
                placeholder="sélectionnez un fournisseur"
                [loading]="isLoadingContacts"
                [clearable]="true"
                [searchable]="true"
                notFoundText="Aucun fournisseur trouvé"
                appendTo="body"
            ></ng-select>

            <ng-select
                *ngIf="showDocumentSelect"
                class="rapport-filter-ng-select"
                [items]="rapportDocumentOptions"
                bindLabel="label"
                bindValue="id"
                [(ngModel)]="selectedDocumentType"
                name="rapport_document"
                placeholder="sélectionnez un document"
                [clearable]="true"
                [searchable]="false"
                appendTo="body"
                dropdownClass="rapport-ng-dropdown-panel"
            ></ng-select>

            <div *ngIf="showTauxInput" class="taux-field" style="width: 250px">
                <span class="taux-label">Taux :</span>

                <input
                        class="taux-stepper-input"
                        type="number"
                        [min]="0"
                        [step]="tauxStep"
                        [(ngModel)]="taux"
                        style=" text-align: center;">
                <button type="button" class="button-inc-quantity" (click)="incrementTaux()">
                    <span data-feather="chevron-up" class="flech"></span>
                </button>
                <button type="button" class="button-dec-quantity" (click)="decrementTaux()">
                    <span data-feather="chevron-down"></span>
                </button>
            </div>

        </div>

    </div>
    <div class="card-body pt-0 rapport-detail-card__body"   >
        <div *ngIf="isVenteParClientReport && isLoadingVenteParClientDocs" class="px-3 py-2 text-muted small">
            Chargement des documents…
        </div>

        <div *ngIf="showRetenuesFournisseurContactBanner" class="retenues-fournisseur-alert" role="alert">
            <span class="retenues-fournisseur-alert__icon" aria-hidden="true">!</span>
            <div class="retenues-fournisseur-alert__content">
                <strong class="retenues-fournisseur-alert__title">Veuillez sélectionner un contact</strong>
                <p class="retenues-fournisseur-alert__subtitle mb-0">
                    Pour afficher le total des retenues des fournisseurs, veuillez sélectionner un contact !
                </p>
            </div>
            <button
                type="button"
                class="retenues-fournisseur-alert__close"
                (click)="dismissRetenuesFournisseurBanner()"
                aria-label="Fermer l'alerte"
            >&times;</button>
        </div>
        <div [class.tva-report-wrap]="isTvaVenteOuAchatsReport" >
            <table
                class="table align-middle mb-0"
                [class.tva-report-table]="isTvaVenteOuAchatsReport"
            >
                <thead class="custom-thead">
                <tr>
                    <th
                        *ngFor="let col of tableColumns"
                        [class.tva-report-th]="isTvaVenteOuAchatsReport"
                    >{{ col }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of reportTableRows" [class.tva-report-tr]="isTvaVenteOuAchatsReport" class="report-data-row">
                    <td
                        *ngFor="let col of tableColumns; let i = index; let first = first; let last = last"
                        [ngClass]="tdClasses(first, last)"
                    >
                        <a
                            *ngIf="isTvaVenteOuAchatsReport && first && getRowCell(row, i, col)"
                            href="javascript:void(0)"
                            class="tva-report-doc-link"
                        >{{ getRowCell(row, i, col) }}</a>
                        <span
                            *ngIf="isTvaVenteOuAchatsReport && first && !getRowCell(row, i, col)"
                            class="tva-report-doc-placeholder"
                        >—</span>
                        <span *ngIf="!(isTvaVenteOuAchatsReport && first)">{{ getRowCell(row, i, col) }}</span>
                    </td>
                </tr>
                <tr *ngIf="data.length === 0 && !isLoadingRapportDocuments" class="report-placeholder-row" [class.tva-report-tr]="isTvaVenteOuAchatsReport">
                    <td
                        *ngFor="let col of tableColumns; let i = index; let first = first; let last = last"
                        [ngClass]="tdClasses(first, last)"
                    >
                        <span *ngIf="isTvaVenteOuAchatsReport && first" class="tva-report-doc-placeholder">—</span>
                    </td>
                </tr>
                </tbody>
                <tfoot *ngIf="isTvaVenteOuAchatsReport" class="tva-report-tfoot">
                <tr>
                    <td [attr.colspan]="tableColumns.length - 1" class="tva-report-tfoot-label">TOTAL TVA</td>
                    <td class="tva-report-tfoot-value">{{ tvaFooterTotalDisplay }}</td>
                </tr>
                </tfoot>
            </table>

            <div *ngIf="isTvaVenteOuAchatsReport" class="tva-report-pagination">
                <div class="tva-report-pagination__left">
                    <span class="tva-report-pagination__label">Afficher</span>
                    <select class="form-control form-control-sm tva-report-page-size" [(ngModel)]="tvaPageSize">
                        <option *ngFor="let n of tvaPageSizeOptions" [ngValue]="n">{{ n }}</option>
                    </select>
                </div>
                <div class="tva-report-pagination__right">
                    <button type="button" class="tva-report-page-btn" disabled aria-label="Première page">&laquo;</button>
                    <button type="button" class="tva-report-page-btn" disabled aria-label="Page précédente">&lsaquo;</button>
                    <button type="button" class="tva-report-page-btn tva-report-page-btn--active">1</button>
                    <button type="button" class="tva-report-page-btn">2</button>
                    <button type="button" class="tva-report-page-btn">3</button>
                    <button type="button" class="tva-report-page-btn">&rsaquo;</button>
                    <button type="button" class="tva-report-page-btn">&raquo;</button>
                </div>
            </div>

            <!-- Pagination documents vente / achat (même design que shared.component) -->
            <div *ngIf="isDocumentsRapportPaginated" class="row d-flex pagination-bar rapport-vente-client-pagination">
                <div class="col-md-3 col-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <label class="d-flex align-items-center rapport-vente-client-pagination__afficher">
                            Afficher
                            <select
                                class="form-control mx-2 rapport-vente-client-pagination__select"
                                [(ngModel)]="venteParClientPageSize"
                                (ngModelChange)="onVenteParClientPageSizeChange()"
                            >
                                <option *ngFor="let n of venteParClientPageSizeOptions" [ngValue]="n">{{ n }}</option>
                            </select>
                        </label>
                    </div>
                </div>
                <div class="col-md-9 col-12 pagination-col">
                    <div class="pagination-row d-flex justify-content-end gap-2">
                        <div
                            class="page-box"
                            [class.disabled]="venteParClientCurrentPage === 1"
                            (click)="venteParClientCurrentPage > 1 && changeVenteParClientPage(1)"
                        >«</div>
                        <div
                            class="page-box"
                            [class.disabled]="venteParClientCurrentPage === 1"
                            (click)="venteParClientCurrentPage > 1 && changeVenteParClientPage(venteParClientCurrentPage - 1)"
                        >‹</div>
                        <div
                            *ngFor="let page of venteParClientPages"
                            class="page-box"
                            [class.active]="page === venteParClientCurrentPage"
                            (click)="changeVenteParClientPage(page)"
                        >{{ page }}</div>
                        <div
                            class="page-box"
                            [class.disabled]="venteParClientCurrentPage === venteParClientTotalPages"
                            (click)="venteParClientCurrentPage < venteParClientTotalPages && changeVenteParClientPage(venteParClientCurrentPage + 1)"
                        >›</div>
                        <div
                            class="page-box"
                            [class.disabled]="venteParClientCurrentPage === venteParClientTotalPages"
                            (click)="venteParClientCurrentPage < venteParClientTotalPages && changeVenteParClientPage(venteParClientTotalPages)"
                        >»</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>
